export const FETCH_URL =
  "https://router-da674-default-rtdb.firebaseio.com/items.json";

export const TIMEOUT_SEC = 20;
export const WAIT_TIME = 1;

export const ERROR_MESSAGE = `Unable to display the dishes. Please try later :( `;
